export default "__VITE_ASSET__BcGtjRVI__"